import React from 'react';
import AppShell from '../components/layout/AppShell';
import StudentDashboard from '../features/dashboard/StudentDashboard';

const DashboardPage = () => {
  return (
    <AppShell>
      <StudentDashboard />
    </AppShell>
  );
};

export default DashboardPage;
